module.exports = __webpack_public_path__ + "static/media/IC_agentic_ai.0ac079c9.svg";